// import logo from './logo.svg';
import "./App.css";
import RoutesPage from "./components/routes/routes";

function App() {
  return <RoutesPage />;
}

export default App;
